import _tokens from './tokens.js'
import { extractUnits } from './utils.js'

import { UnitType } from '@exodus/currency'

const name = 'tezos'
const displayName = 'Tezos'
const ticker = 'XTZ'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#2C7DF7'
const gradientColors = ['#2CB0F7', '#2C7DF7']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  mutez: 0,
  XTZ: 6,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://tzstats.com/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://tzstats.com/operation/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Tezos is a platform for smart contracts and decentralized applications. Tezos is about formalizing blockchain governance, as the stakeholders govern the protocol.',
  reddit: 'https://www.reddit.com/r/tezos/',
  twitter: 'https://twitter.com/tezos',
  website: 'https://tezos.com',
  telegram: 'https://t.me/tezosplatform',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export const tokens = _tokens.map((token) => {
  const units = extractUnits(token)
  return {
    ...token,
    assetId: `${token.contract}:${token.tokenId}`,
    assetType: 'TEZOS_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    currency: UnitType.create(units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    tokenId: token.tokenId,
    toString: () => token.name,
    units,
  }
})

export default [asset, ...tokens]
